var map = {
	"./auoas.jpg": 88,
	"./buckingham.jpg": 89,
	"./bundesministerium.jpg": 90,
	"./ebs.jpg": 91,
	"./esf.jpg": 92,
	"./eu_commission.jpg": 93,
	"./eu_institute.jpg": 94,
	"./exist.jpg": 95,
	"./foggia.jpg": 96,
	"./gesis.jpg": 97,
	"./glu.jpg": 98,
	"./heidelberg.jpg": 99,
	"./hertie.jpg": 100,
	"./htw_berlin.jpg": 101,
	"./itmo.png": 102,
	"./jacobs.jpg": 103,
	"./jgu.jpg": 104,
	"./kit.jpg": 105,
	"./land_der_ideen.jpg": 106,
	"./luiss.jpg": 107,
	"./mhmk.jpg": 108,
	"./open_education.jpg": 109,
	"./osnabrueck.jpg": 110,
	"./padova.jpg": 111,
	"./passau.jpg": 112,
	"./pavia.jpg": 113,
	"./pfur.jpg": 114,
	"./reutlingen.jpg": 115,
	"./rwth.jpg": 116,
	"./salford.jpg": 117,
	"./stifterverband.jpg": 118,
	"./tpu.jpg": 119,
	"./tsu.jpg": 120,
	"./tusur.jpg": 121,
	"./udima.jpg": 122,
	"./unep.jpg": 123,
	"./usi.jpg": 124,
	"./whu.jpg": 125,
	"./wwf.jpg": 126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;